import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-go-to-project',
  templateUrl: './go-to-project.component.html',
  styleUrls: ['./go-to-project.component.scss']
})
export class GoToProjectComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
  }
  goToProject(){
    // this.router.navigate(['/company/' + this.route.snapshot.paramMap.get('id') + '/'+ this.route.snapshot.paramMap.get('idp') + '/test']);
    this.router.navigate(['/company/' + this.route.snapshot.paramMap.get('id') + '/'+ this.route.snapshot.paramMap.get('idp')]);
  }

}
